import React, { useState } from "react";
import { PageContainer, PageHeader, PageTitle } from "../../components/PageLayout";
import { UserStore } from "../../stores/UserStore/UserStore";
import { useUnit } from "effector-react";
import StationSelect from "./components/StationSelect/StationSelect";
import { Station } from "../../types/stations.types";
import WeekSchedule from "./components/WeekSchedule/WeekSchedule";

const ScheduleSettings: React.FC = () => {
  const { station: userStationName } = useUnit(UserStore);

  const [selectedStation, setSelectedStation] = useState<Station>(
    {} as Station
  );

  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>Configuração de horários</PageTitle>
        <StationSelect
          userStationName={userStationName}
          setSelectedStation={setSelectedStation}
        />
      </PageHeader>
      <WeekSchedule stationId={selectedStation.id} />
    </PageContainer>
  );
};

export default ScheduleSettings;
